import { DatePickerPassThroughOptions } from "primevue/datepicker";
import type { PassThrough } from "@primevue/core";

export const getDatepickerPtOptions = (inputClasses: string[]): PassThrough<DatePickerPassThroughOptions> => ({
    root: "ds-datepicker__picker",
    pcInputText: (options) => ({
        root: {
            active: options.state.overlayVisible,
            class: [inputClasses, "ds-datepicker__input"],
        },
    }),
    inputIconContainer: "ds-datepicker__input-slot ds-form-field__input-slot ds-form-field__input-slot--right",
    panel: "ds-datepicker__panel",
    calendarContainer: "ds-datepicker__calendar-container",
    calendar: "ds-datepicker__calendar",
    header: "ds-datepicker__header",
    pcPrevButton: {
        root: "button button--interaction ds-datepicker__header-button",
        label: "d-none",
    },
    pcNextButton: {
        root: "button button--interaction ds-datepicker__header-button",
        label: "d-none",
    },

    title: "ds-datepicker__header-title",
    selectMonth: "ds-datepicker__header-month",
    selectYear: "ds-datepicker__header-year",
    decade: "ds-datepicker__header-decade",
    dayView: "ds-datepicker__day-table",
    dayCell: "ds-datepicker__day-cell",
    weekDay: "ds-datepicker__week",
    day: "ds-datepicker__day",
    monthView: "ds-datepicker__month-table",
    month: "ds-datepicker__month",
    yearView: "ds-datepicker__year-table",
    year: "ds-datepicker__year",
    timePicker: "ds-datepicker__time-picker",
    separatorContainer: "ds-datepicker__time-separator",
    hourPicker: "ds-datepicker__hour-picker",
    hour: "ds-datepicker__hour",
    minutePicker: "ds-datepicker__minute-picker",
    minute: "ds-datepicker__minute",
    secondPicker: "ds-datepicker__second-picker",
    second: "ds-datepicker__second",
    ampmPicker: "ds-datepicker__amp-picker",
    ampm: "ds-datepicker__amp",
    buttonbar: "ds-datepicker__buttonbar",
    pcDecrementButton: {
        root: "button button--interaction ds-datepicker__time-button",
        label: "d-none",
    },
    pcIncrementButton: {
        root: "button button--interaction ds-datepicker__time-button",
        label: "d-none",
    },
    transition: {
        name: "ds-datepicker-panel",
    },
});
